var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return (_vm.showFullScreenBtn)?_c('div',{staticClass:"full-screen-btn-con",on:{"click":_vm.handleChange}},[_c('Tooltip',{attrs:{"content":_vm.value ? _vm.L('ExitFullScreen') : _vm.L('FullScreen'),"placement":"bottom"}},[_c('Icon',{attrs:{"type":_vm.value ? 'arrow-shrink' : 'arrow-expand',"size":23}})],1)],1):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }